import { useAtomCallback } from "jotai/utils";
import { useCallback } from "react";
import { useDispatchTrainingResourceBuilderAction } from "./useDispatchTrainingResourceBuilderAction";
import { TranslationSetObjectInput } from "@src/types.generated";

export const useDispatchSetTrainingResourceNameAction = (): Return => {
  const dispatch = useDispatchTrainingResourceBuilderAction();
  return useAtomCallback(
    useCallback(
      (get, _set, args) => {
        dispatch({
          action: {
            payload: {
              setTrainingResourceNameAction: {
                name: args.newName,
              },
            },
          },
          inverseAction: {
            payload: {
              setTrainingResourceNameAction: {
                name: args.oldName,
              },
            },
          },
        });
      },
      [dispatch],
    ),
  );
};
export type Return = (args: {
  newName: TranslationSetObjectInput;
  oldName: TranslationSetObjectInput;
}) => void;
